import { useQuery } from '@apollo/client';
import { validateZipCode } from '@perch-labs/warbler';
import { FETCH_COUNTIES_BY_ZIP, SalesforceCountyOption } from '~/services/fetch-counties-by-zip';

interface CountiesByZipQuery {
  countiesByZip: SalesforceCountyOption[];
}

interface CountiesByZipVariables {
  zipCode: string;
}

export interface CountiesForZipState {
  counties: SalesforceCountyOption[];
  loading: boolean;
  error?: Error;
}

export const useCountiesForZip = (zipCode: string, enabled: boolean): CountiesForZipState => {
  const shouldFetch = enabled && validateZipCode(zipCode);
  const { data, error, loading, variables } = useQuery<CountiesByZipQuery, CountiesByZipVariables>(
    FETCH_COUNTIES_BY_ZIP,
    {
      // Without this, loading stays false when the zip changes and the previous zip's counties stay on data.
      notifyOnNetworkStatusChange: true,
      skip: !shouldFetch,
      variables: { zipCode },
    },
  );

  const resultIsForZip = shouldFetch && variables?.zipCode === zipCode;
  if (!resultIsForZip || loading) {
    return { counties: [], loading: shouldFetch };
  }

  if (error) {
    return { counties: [], loading: false, error };
  }

  return { counties: data?.countiesByZip ?? [], loading: false };
};
